import React from 'react';
import { createUseStyles } from 'react-jss';
import { useMenuContext } from './MenuContext';
const useStyles = createUseStyles({
    menuToggle: {
        cursor: 'pointer',
    },
});
function MenuToggle({ children }) {
    const classes = useStyles();
    const [isShown, setIsShown] = useMenuContext();
    const toggle = () => setIsShown(!isShown);
    const blur = () => setTimeout(toggle, 100);
    return (React.createElement("div", { className: classes.menuToggle, role: "button", tabIndex: 0, onKeyDown: toggle, onClick: toggle, onBlur: blur }, children));
}
export default MenuToggle;
//# sourceMappingURL=MenuToggle.js.map